import {
  ModalCloseButton as ChakraModalCloseButton,
  ModalCloseButtonProps as ChakraModalCloseButtonProps,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps } from '../../types'

type ModalCloseButtonProps =
  SwashbuckleComponentProps<ChakraModalCloseButtonProps>

export const ModalCloseButton = ({
  'data-qa': dataQa,
  className,
  ...chakraModalCloseButtonProps
}: ModalCloseButtonProps) => {
  return (
    <ChakraModalCloseButton
      data-qa={dataQa}
      className={className}
      {...chakraModalCloseButtonProps}
    />
  )
}

ModalCloseButton.displayName = 'ModalCloseButton'
